import styled from '@emotion/styled'

export const StyledFooter = styled.footer`
  background-color: var(--color-black-1);
  border-top: 3px solid var(--color-primary);
  padding: 20px;
  color: var(--color-secondary);
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 30px;

  a.develop-by {
    display: inline-block;
    width: 100%;
    font-size: 14px;
    color: var(--color-gray-dark);

    span {
      display: inline-block;
      margin-right: 10px;
    }

    img {
      width: 100px;
    }
  }

  .rights {
    width: 300px;
  }

  .reclame-aqui {
    border-radius: 5px;

    & > div {
      & > a {
        background-color: transparent !important;

        & > div {
          border-color: var(--color-primary) !important;
        }
      }
    }
  }

  @media (min-width: 760px) {
    text-align: left;
    flex-direction: row;
    gap: 10px;

    a.develop-by {
      width: 230px;
      text-align: right;
    }
  }
`

export const StyledWhats = styled.div`
  position: fixed;
  bottom: -100%;
  right: 20px;
  overflow: hidden;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  padding: 10px;
  background-color: #00e676;
  transition: all .2s ease-in-out;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, .4);

  &.show { 
    bottom: 140px;
  }

  a {
    height: 40px;
    display: block;
    width: 40px;
    vertical-align: middle;

    i {
      font-size: 40px;
      color: var(--color-light);
      line-height: 40px;
    }
    
    span {
      display: inline-block;
      overflow: hidden;
      width: 0;
      height: 0;
      color: var(--color-light);
      font-size: 18px;
      transition: all .2s ease-in-out;
    }
  }

  &:hover {
    width: 200px;
    border-radius: 50px;

    a {
      width: 100%;

      i {
        width: 40px;
      }

      span {
        width: calc(100% - 50px);
        height: auto;
      }
    }
  }

  @media (min-width: 760px) {
    &.show { 
      bottom: 144px;
    }
  }
`

export const LinkPolitices = styled.a`
  color: var(--color-secondary);
  text-decoration: none;
  margin-bottom: 10px;
  display: block;

  & > i {
    margin-right: 8px;
  }

  &:hover {
    text-decoration: underline;
    color: var(--color-primary);
  }
` 
